import { createEnumGuard } from '#/utils/typeGuards'

export { getCardStatusLabelKey } from '#/utils/cardStatus'

export const PROFILE_TAB_KEYS = ['details', 'card', 'budget', 'settings'] as const
export type TProfileTab = (typeof PROFILE_TAB_KEYS)[number]
export const isProfileTab = createEnumGuard(PROFILE_TAB_KEYS)

export const readProfileTab = (search: Record<string, unknown>): TProfileTab => {
  const tab = search.tab

  return typeof tab === 'string' && isProfileTab(tab) ? tab : 'details'
}
